export type TerrainMode = 'flat' | 'slope';
export type PlinthLengthMm = 500 | 700 | 900;

export interface SiteConditions {
    plinthLengthMm: PlinthLengthMm;
    minBuriedDepthMm: number;
    terrainMode: TerrainMode;
    slopeAcrossPercent: number;
    slopeAlongPercent: number;
}

export const DEFAULT_SITE_CONDITIONS: SiteConditions = {
    plinthLengthMm: 500,
    minBuriedDepthMm: 100,
    terrainMode: 'flat',
    slopeAcrossPercent: 0,
    slopeAlongPercent: 0,
};

export const PLINTH_LENGTH_OPTIONS: PlinthLengthMm[] = [500, 700, 900];

export function getTerrainSlopeAtPoint(
    siteConditions: SiteConditions,
    xM: number,
    zM: number,
): number {
    if (siteConditions.terrainMode !== 'slope') {
        return 0;
    }

    return (
        xM * (siteConditions.slopeAcrossPercent / 100)
        + zM * (siteConditions.slopeAlongPercent / 100)
    );
}
